import React from "react"

import { PrimaryButton } from "components/buttons"
import { ButtonProps } from "components/buttons/shared"

import { baseRoutes } from "routes"

export const GetStartedButton = ({ sizing = "stretch" }: ButtonProps) => (
  <PrimaryButton to={baseRoutes.choosePlan()} my={5} sizing={sizing}>
    Get started
  </PrimaryButton>
)
